import { ErrorText, FieldLabel, FieldWrapper, RequiredMark } from './FormField.styles';
import type { FormFieldProps } from './FormField.types';

export function FormField({ label, required, error, children, fullWidth }: FormFieldProps) {
  return (
    <FieldWrapper $fullWidth={fullWidth}>
      <FieldLabel>
        {label}
        {required && <RequiredMark>*</RequiredMark>}
      </FieldLabel>
      {children}
      {error && <ErrorText>{error}</ErrorText>}
    </FieldWrapper>
  );
}
